export const BorderStyle =
    'border border-gray-200 focus:ring-1 focus:ring-blue-500 focus:outline-none';

export const buttonCss =
    'disabled:opacity-50 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded float-right';
